module.exports = __webpack_public_path__ + "img/vlt_voidlightvlt.4169d6b.png";